import { render, staticRenderFns } from "./CreateReferralLocation.vue?vue&type=template&id=16b25be7&scoped=true"
import script from "./CreateReferralLocation.vue?vue&type=script&lang=js"
export * from "./CreateReferralLocation.vue?vue&type=script&lang=js"
import style0 from "./CreateReferralLocation.vue?vue&type=style&index=0&id=16b25be7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b25be7",
  null
  
)

export default component.exports